import { render } from "./ManageRoles.vue?vue&type=template&id=3cfc95de"
import script from "./ManageRoles.vue?vue&type=script&lang=js"
export * from "./ManageRoles.vue?vue&type=script&lang=js"

import exportComponent from "/root/hr-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__